import Logo from "@/components/base/Logo";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const services = [
    { label: "Réparation volet roulant", href: "/reparation-volet-roulant" },
    { label: "Dépannage urgence", href: "/depannage-urgence" },
    { label: "Remplacement de moteur", href: "/moteur-somfy" },
    { label: "Motorisation", href: "/motorisation-somfy" },
    { label: "Électrification", href: "/electrification-somfy" },
    { label: "Pose & installation", href: "/pose-volet-roulant" },
    { label: "Sangle & cordon", href: "/sangle-volet-roulant" },
    { label: "Tablier & lames", href: "/tablier-volet-roulant" },
  ];

  const villes = [
    { label: "Strasbourg", href: "/" },
    { label: "Haguenau", href: "/haguenau" },
    { label: "Schiltigheim", href: "/schiltigheim" },
    { label: "Illkirch-Graffenstaden", href: "/illkirch-graffenstaden" },
    { label: "Sélestat", href: "/selestat" },
    { label: "Lingolsheim", href: "/lingolsheim" },
    { label: "Obernai", href: "/obernai" },
    { label: "Molsheim", href: "/molsheim" },
    { label: "Toutes les villes", href: "/zones-d-intervention" },
  ];

  return (
    <footer id="contact" className="bg-[#143A66] text-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
          {/* Colonne 1 — Marque */}
          <div className="lg:col-span-1">
            <div className="mb-4">
              <Logo light />
            </div>
            <p className="text-[#E2E8F0] text-sm leading-relaxed mb-4">
              Réparation, motorisation et pose de volets roulants à Strasbourg et dans tout le Bas-Rhin. Techniciens locaux, intervention 24h, devis gratuit.
            </p>
            <p className="text-[#9DB2C8] text-xs leading-relaxed">
              Toutes marques : Somfy, Nice, Simu, Bubendorff, Profalux, Elero.
            </p>
          </div>

          {/* Colonne 2 — Nos services */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">
              Nos services
            </h4>
            <ul className="space-y-2.5">
              {services.map((s) => (
                <li key={s.href}>
                  <a
                    href={s.href}
                    className="text-[#E2E8F0] text-sm hover:text-[#00B3A4] transition-colors"
                  >
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Colonne 3 — Zones d'intervention */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">
              Zones d'intervention
            </h4>
            <ul className="space-y-2.5">
              {villes.map((v) => (
                <li key={v.href}>
                  <a
                    href={v.href}
                    className="text-[#E2E8F0] text-sm hover:text-[#00B3A4] transition-colors"
                  >
                    {v.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Colonne 4 — Contact */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">
              Contact
            </h4>
            <div className="space-y-3 text-sm">
              <p className="text-[#E2E8F0] leading-relaxed">
                <span className="text-[#9DB2C8] text-xs uppercase tracking-wider block mb-0.5">Atelier</span>
                82 Rue de Heidenberg<br />67200 Strasbourg
              </p>
              <p>
                <span className="text-[#9DB2C8] text-xs uppercase tracking-wider block mb-0.5">Téléphone</span>
                <a href="tel:0374473240" className="text-white font-semibold text-base hover:text-[#00B3A4] transition-colors">
                  03 74 47 32 40
                </a>
              </p>
              <p className="text-[#E2E8F0] leading-relaxed">
                <span className="text-[#9DB2C8] text-xs uppercase tracking-wider block mb-0.5">Horaires</span>
                Lun–Ven 8h–19h<br />Sam 8h–12h
              </p>
            </div>
            <a
              href="/contact"
              className="inline-flex items-center mt-5 px-5 py-2.5 bg-[#00B3A4] text-white text-sm font-semibold rounded-md hover:bg-[#00B3A4]/90 transition-colors whitespace-nowrap"
            >
              Devis gratuit
            </a>
            <div className="mt-4 flex flex-wrap gap-x-4 gap-y-1">
              <a href="/contact" className="text-[#9DB2C8] text-xs hover:text-[#00B3A4] transition-colors">Contact</a>
              <a href="/tarifs" className="text-[#9DB2C8] text-xs hover:text-[#00B3A4] transition-colors">Tarifs</a>
              <a href="/avis" className="text-[#9DB2C8] text-xs hover:text-[#00B3A4] transition-colors">Avis</a>
            </div>
          </div>
        </div>
      </div>

      {/* Barre du bas */}
      <div className="bg-[#0F2E52]">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-[#9DB2C8] text-xs text-center sm:text-left">
              © {currentYear} DF PRO — Dépan&apos;Volets Strasbourg. Tous droits réservés.
            </p>
            <div className="flex gap-5">
              <a href="/mentions-legales" className="text-[#9DB2C8] text-xs hover:text-[#00B3A4] transition-colors">
                Mentions légales
              </a>
              <a href="/politique-confidentialite" className="text-[#9DB2C8] text-xs hover:text-[#00B3A4] transition-colors">
                Politique de confidentialité
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}